import React, { useState, useEffect } from 'react'
import Helper from '../helper';
import Auth from '../services/auth.service';
import logo from "../../assets/images/differentiallogo.png";
import CountDownTimer from '../components/CountDownTimer';


const Login = () => {

    const [isView, setIsView] = useState(0);
    const [isValid, setIsValid] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [username, setUsername] = useState('');
    const [applicationId, setApplicationId] = useState('');
    const [otp, setOtp] = useState('');

    useEffect(() => {
        if (localStorage.getItem('LOG_MSG')) {
            Helper.success(localStorage.getItem('LOG_MSG'));
            localStorage.removeItem('LOG_MSG');
        }
    }, []);

    const handleSendOtp = e => {
        e.preventDefault();

        sendOtp();
    }

    const handleChange = e => {
        setUsername(e.target.value)
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        if (pattern.test(e.target.value)) {
            setIsValid(false)
        } else {
            setIsValid(true)
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        var formData = new FormData();
        formData.append('otp', otp);
        formData.append('application_id', applicationId);

        Auth.loginOtpVerify(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                Helper.success(res.message);
                localStorage.setItem('user', JSON.stringify(res.data));
                window.location.href = '/stepform';
            } else {
                Helper.validationError(res);
            }
        }).catch(err => console.log(err));
    }

    const sendOtp = () => {
        setIsLoading(true)
        var formData = new FormData();
        formData.append('username', username);

        Auth.loginSendOtp(formData).then((response) => {
            var res = response.data;
            if (res.success === true) {
                setIsView(1);
                Helper.success(res.message);
                setApplicationId(res.data.application_id);
            } else {
                Helper.validationError(res);
            }
            setIsLoading(false)
        }).catch(err => setIsLoading(false));
    }

    return (
        <div className="page-wrapper">
            <section className="login-section">
                <div className="row">
                    <div className="col-lg-5 col-md-12 col-sm-12  vh-100">
                        <div className="login-container ">
                            <div className="form-wrapper">
                                <div className="logo-wrapper text-center">
                                    <img src={logo} />
                                </div>
                                <h2>LOGIN</h2>
                                <form autoComplete="off" onSubmit={handleSubmit}>
                                    <div className="form-group">
                                        <label htmlFor="name">Enter Email ID <span className="asterisk">*</span></label>
                                        <div className="input-wrap d-flex">
                                            <input type="text" name='username' value={username} onChange={handleChange} className="form-control" autoFocus />
                                            <div className="otp-send-btn otp-send-cust" disabled={isValid ? true : false}>
                                                {isView == 0 && <a className={isLoading ? "otp-send btn-loading" : "otp-send"} onClick={handleSendOtp}>Send OTP</a>}
                                                {isView == 1 && applicationId && <a className="otp-send"><CountDownTimer seconds={180} setIsView={setIsView} /></a>}
                                                {isView == 2 && applicationId && <a className={isLoading ? "otp-send btn-loading" : "otp-send"} onClick={handleSendOtp}>Resend OTP</a>}
                                            </div>
                                        </div>
                                        <div className="text-muted"><small>Note: Please login using the verified Email ID.</small></div>
                                        <div className="validationAlert"></div>
                                    </div>
                                    {isView == 1 || isView == 2 ?
                                        <div className="form-group">
                                            <label htmlFor="name">Enter OTP <span className="asterisk">*</span></label>
                                            <div className="input-wrap d-flex">
                                                <input type="text" name='otp' value={otp} onChange={(e) => setOtp(e.target.value)} className="form-control" readOnly={isView == 1 ? false : true} />

                                            </div>
                                            <div className="validationAlert"></div>
                                        </div> : null
                                    }

                                    <div className="form-group button-outer">
                                        <div className='go-back-link'>
                                            <a href='https://www.differential.co.za/'>Back to website</a>
                                        </div>
                                        <div className="button-wrapper">
                                            {otp && otp.length > 0 ?
                                                <button type="submit" className="btn btn-primary">Login</button> :
                                                <button type="submit" className="btn btn-primary" disabled>Login</button>
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-12 pl-0 d-none d-lg-block d-xl-block">
                        <div className="background-wrapper"></div>
                    </div>
                </div>
            </section>
        </div>
    )
}



export default Login;